<template>
  <div class="v-spinner centrado-spinner" v-show="loading" v-if="propLoading">
    <div
      class="v-sync v-sync1"
      v-bind:style="[spinnerStyle, spinnerDelay1]"
    ></div>
    <div
      class="v-sync v-sync2"
      v-bind:style="[spinnerStyle, spinnerDelay2]"
    ></div>
    <div
      class="v-sync v-sync3"
      v-bind:style="[spinnerStyle, spinnerDelay3]"
    ></div>
  </div>

  <div id="inspire" class="fuente" v-else>
    <!-- Header global que cubre toda la pantalla -->
    <div class="global-header" :style="headerStyle">
      <div class="header-content">
        <v-btn
          icon
          class="menu-toggle-btn"
          @click="toggleDrawer"
          v-if="isMobile"
        >
          <v-icon color="#1e293b">mdi-menu</v-icon>
        </v-btn>

        <!-- Título centrado -->
        <div class="header-center">
          <div class="logo-section">
            <div class="logo-icon">
              <v-icon color="white" size="28">mdi-clipboard-check</v-icon>
            </div>
            <div class="logo-text">
              <h2 class="system-title">Revisión</h2>
              <p class="system-subtitle">Gestión de Procesos</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-container fluid class="pa-0" style="margin-top: 70px">
      <v-navigation-drawer
        class="ultra-modern-sidebar"
        v-model="drawer"
        fixed
        :width="isMobile ? 260 : 300"
        :temporary="isMobile"
        :permanent="!isMobile"
      >
        <!-- User profile card en sidebar -->
        <div class="user-profile-sidebar">
          <div class="user-avatar-sidebar">
            <v-avatar size="70" class="user-avatar-main">
              <v-icon size="35" color="white">mdi-account</v-icon>
            </v-avatar>
          </div>
          <div class="user-info-sidebar">
            <h3 class="user-name-sidebar">{{ nombre }}</h3>
          </div>
        </div>

        <!-- Navigation menu ultra moderno -->
        <div class="sidebar-content">
          <div class="nav-section">
            <h3 class="nav-section-title">Navegación</h3>
            <v-list class="nav-menu-ultra" dense>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                :to="item.link"
                class="nav-item-ultra"
                link
              >
                <div class="nav-item-content">
                  <div class="nav-icon-wrapper">
                    <v-icon class="nav-icon-ultra" v-text="item.icon"></v-icon>
                  </div>
                  <div class="nav-text-wrapper">
                    <span class="nav-text-ultra" v-text="item.text"></span>
                    <div class="nav-indicator"></div>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </div>

          <!-- Spacer -->
          <div class="sidebar-spacer"></div>

          <!-- Quick actions integradas -->
          <div class="quick-actions-integrated">
            <h3 class="nav-section-title">Acciones Rápidas</h3>
            <v-btn class="action-btn-integrated" small outlined @click="logout">
              <v-icon left small>mdi-logout</v-icon>
              Cerrar Sesión
            </v-btn>
          </div>
        </div>
      </v-navigation-drawer>

      <!-- Main content area -->
      <v-main
        :class="['main-content', { 'main-content--overlay': isMobile }]"
        :style="mainContentStyle"
      >
        <v-container fluid class="content-container">
          <router-view to="children" />
        </v-container>
      </v-main>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import env from "../env";
export default {
  name: "SyncLoader",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "#1b4695",
    },
    size: {
      type: String,
      default: "30px",
    },
    margin: {
      type: String,
      default: "2px",
    },
    radius: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      propLoading: this.loading,
      nombre: localStorage.getItem("nombre"),
      rol: localStorage.getItem("rol"),
      drawer: true,
      isMobile: false,
      items: [
        {
          text: "TODOS LOS PROCESOS",
          icon: "mdi-application-settings",
          link: "/Revision/procesosRevision",
        },
      ],

      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: "inline-block",
        animationName: "v-syncStretchDelay",
        animationDuration: "0.6s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
        animationFillMode: "both",
      },
      spinnerDelay1: {
        animationDelay: "0.07s",
      },
      spinnerDelay2: {
        animationDelay: "0.14s",
      },
      spinnerDelay3: {
        animationDelay: "0.21s",
      },
    };
  },
  computed: {
    headerStyle() {
      const offset = !this.isMobile && this.drawer ? 300 : 0;

      return {
        left: `${offset}px`,
        width: `calc(100% - ${offset}px)`,
      };
    },
    mainContentStyle() {
      const offset = !this.isMobile && this.drawer ? 300 : 0;

      return {
        marginLeft: `${offset}px`,
      };
    },
  },
  methods: {
    // metodo par cerrar sesión y remover los datos del localStorage
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    handleResize() {
      const viewportIsMobile = window.innerWidth <= 1366;

      if (viewportIsMobile && !this.isMobile) {
        this.isMobile = true;
        this.drawer = false;
      } else if (!viewportIsMobile && this.isMobile) {
        this.isMobile = false;
        this.drawer = true;
      }
    },
  },
  mounted() {
    if (typeof window !== "undefined") {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
    setTimeout(() => {
      this.propLoading = false;
    }, 1000);
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  },
};
</script>

<style>
/* ===== FUENTES Y BASE ===== */
.fuente {
  font-family: "Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont,
    sans-serif !important;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
}

/* ===== HEADER GLOBAL CON GLASSMORPHISM ===== */
.global-header {
  background: #ffffff !important;
  border-bottom: 1px solid #e2e8f0 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  transition: left 0.3s ease, width 0.3s ease;
}

.header-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  height: 70px;
  position: relative;
}

.header-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-toggle-btn {
  position: absolute !important;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent !important;
  box-shadow: none !important;
  display: none !important;
}

.menu-toggle-btn .v-btn__overlay,
.menu-toggle-btn .v-btn__underlay {
  display: none !important;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.system-title {
  font-size: 1.4rem !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  margin: 0 !important;
  line-height: 1.2;
}

.system-subtitle {
  font-size: 0.85rem !important;
  color: #64748b !important;
  margin: 0 !important;
  font-weight: 500;
}

/* ===== SIDEBAR ULTRA MODERNO CON GLASSMORPHISM ===== */
.ultra-modern-sidebar {
  background: #f8fafc !important;
  border-right: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  position: fixed !important;
  z-index: 100 !important;
  top: 0 !important;
  left: 0 !important;
  height: 100vh !important;
}

/* User profile en sidebar profesional */
.user-profile-sidebar {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  border: none !important;
  padding: 1.5rem 1.25rem;
  text-align: center;
  color: white;
  margin: 0 0 1rem 0;
  border-radius: 0;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  position: relative;
  z-index: 10;
}

.user-avatar-sidebar {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.user-avatar-main {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

.user-avatar-main:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.3) !important;
}

.user-info-sidebar {
  text-align: center;
  position: relative;
  z-index: 1;
}

.user-name-sidebar {
  color: white !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  margin: 0.75rem 0 0.5rem 0 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.user-role-sidebar {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 0.85rem !important;
  margin: 0 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.sidebar-content {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.nav-section {
  padding: 0 1.25rem;
  flex: 0 0 auto;
}

.nav-section-title {
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.75rem !important;
  margin-top: 0 !important;
  padding: 0.5rem 1.25rem;
  background: transparent;
  border-radius: 0;
  border-left: none;
}

.nav-menu-ultra {
  padding: 0 !important;
}

.nav-item-ultra {
  margin: 0.5rem 0 !important;
  border-radius: 0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
  background: transparent !important;
  border: none !important;
  padding: 0.75rem 1.25rem !important;
}

.nav-item-content {
  display: flex;
  align-items: center;
  padding: 0 !important;
  position: relative;
}

.nav-icon-wrapper {
  width: 20px;
  height: 20px;
  background: transparent !important;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  transition: all 0.3s ease;
  box-shadow: none;
  border: none;
}

.nav-icon-ultra {
  color: #64748b !important;
  font-size: 1rem !important;
  transition: all 0.3s ease;
}

.nav-text-wrapper {
  flex: 1;
  position: relative;
}

.nav-text-ultra {
  color: #374151 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  transition: all 0.3s ease;
}

.nav-indicator {
  display: none;
}

/* Hover effects minimalistas */
.nav-item-ultra:hover {
  background: #f1f5f9 !important;
  transform: none;
}

.nav-item-ultra:hover .nav-icon-wrapper {
  background: transparent !important;
  transform: none;
}

.nav-item-ultra:hover .nav-icon-ultra {
  color: #3b82f6 !important;
  transform: none;
}

.nav-item-ultra:hover .nav-text-ultra {
  color: #1e293b !important;
  font-weight: 500 !important;
}

/* Active state */
.nav-item-ultra.v-list-item--active {
  background: #eff6ff !important;
  border-left: 3px solid #3b82f6 !important;
}

.nav-item-ultra.v-list-item--active .nav-icon-wrapper {
  background: transparent !important;
}

.nav-item-ultra.v-list-item--active .nav-icon-ultra {
  color: #3b82f6 !important;
}

.nav-item-ultra.v-list-item--active .nav-text-ultra {
  color: #1e293b !important;
  font-weight: 500 !important;
}

/* Sidebar spacer */
.sidebar-spacer {
  flex: 0.6;
}

/* Quick actions integradas */
.quick-actions-integrated {
  padding: 1rem 1.25rem 1rem 1.25rem;
  flex: 0 0 auto;
  border-top: 1px solid #e2e8f0;
  margin-top: 1rem;
}

.action-btn-integrated {
  color: #dc2626 !important;
  border: 1px solid #fecaca !important;
  font-weight: 500 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%) !important;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1) !important;
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.6rem 1rem !important;
}

.action-btn-integrated:hover {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
  color: #b91c1c !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2) !important;
}

.action-btn-integrated .v-icon {
  color: #dc2626 !important;
}

.action-btn-integrated:hover .v-icon {
  color: #b91c1c !important;
}

/* ===== MAIN CONTENT ===== */
.main-content {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
  min-height: calc(100vh - 70px);
  transition: margin-left 0.3s ease;
}

.content-container {
  padding: 2rem !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
}

.main-content--overlay {
  margin-left: 0 !important;
}

/* ===== SPINNER ULTRA MODERNO ===== */
.centrado-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

/* ===== ANIMACIONES ===== */
@-webkit-keyframes v-syncStretchDelay {
  33% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  66% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes v-syncStretchDelay {
  33% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  66% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 960px) {
  .ultra-modern-sidebar {
    width: 100% !important;
  }

  .header-content {
    padding: 0 1rem;
  }

  .logo-section {
    gap: 0.75rem;
  }

  .system-title {
    font-size: 1.2rem !important;
  }

  .user-profile-sidebar {
    padding: 1.5rem 1rem;
  }

  .content-container {
    padding: 1rem !important;
  }
}

@media (max-width: 600px) {
  .header-content {
    padding: 1rem;
  }

  .system-title {
    font-size: 1.1rem !important;
  }

  .system-subtitle {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 1366px) {
  .global-header {
    padding-left: 0;
  }

  .main-content {
    margin-left: 0;
  }

  .content-container {
    padding: 1.5rem !important;
  }

  .content-container .v-data-table {
    overflow-x: auto;
  }

  .menu-toggle-btn {
    display: flex !important;
  }
}

/* ===== EFECTOS ADICIONALES ===== */
.nav-item-ultra::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(99, 102, 241, 0.1),
    transparent
  );
  transition: left 0.6s ease;
}

.nav-item-ultra:hover::before {
  left: 100%;
}

/* Ocultar scrollbar completamente */
.ultra-modern-sidebar {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
  overflow: hidden !important;
}

.ultra-modern-sidebar::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, Opera */
  width: 0 !important;
  height: 0 !important;
}

.sidebar-content {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  overflow: hidden !important;
}

.sidebar-content::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* Ocultar scrollbar en Vuetify navigation drawer */
.v-navigation-drawer {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.v-navigation-drawer::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* Ocultar scrollbar en todos los elementos del sidebar */
.ultra-modern-sidebar * {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.ultra-modern-sidebar *::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
</style>
